import { getAccPath } from 'api/auth';
import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { showSnackbar } from 'hooks/useSnackbar';
import axiosApi from 'utils/axios';

export function checkMediaItemIsUsed(id) {
  return axiosApi
    .get(`${getAccPath()}/assets/${id}/check_use`)
    .then(({ data }) => data?.used)
    .catch((err) => {
      showSnackbar({ text: 'Oops... Problems with checking media item in use', type: SNACKBAR_SKIN.ERROR });

      throw err;
    });
}
